<template>
  <div class="page-container">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#" class="active">{{ $t("management") }} {{ $t("Property") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="main-card">
      <div class="body-grid">
        
        <div class="part" v-if="hasPermission('property_list') || hasPermission('property_add')">
          <h6>{{ $t("real estate") }} / {{ $t("units") }}</h6>
          <ul>
            <li v-if="hasPermission('property_list')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/allproperties">
                {{ $t("all") }} {{ $t("real estate") }} / {{ $t("units") }}
              </router-link>
            </li>
            <li v-if="hasPermission('property_add')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/createproperty">
                {{ $t("add") }} {{ $t("real estate") }} / {{ $t("units") }} {{ $t("new") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="part" v-if="hasPermission('receipt_vouchers') || hasPermission('receipt_voucher_add') || hasPermission('payment_vouchers') || hasPermission('payment_voucher_add')">
          <h6>{{ $t("payment") }} / {{ $t("collection") }}</h6>
          <ul>
            <li v-if="hasPermission('receipt_vouchers')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/allpayments">
                {{ $t("receipts") }} {{ $t("received") }}
              </router-link>
            </li>
            <li v-if="hasPermission('receipt_voucher_add')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/createpayment/0/0">
                {{ $t("add") }} {{ $t("receipts") }} {{ $t("received") }}
              </router-link>
            </li>
            <li v-if="hasPermission('payment_vouchers')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/AllOwnerReceipts">
                {{ $t("receipts") }} {{ $t("paid") }}
              </router-link>
            </li>
            <li v-if="hasPermission('payment_voucher_add')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/CreateReceiptOwner">
                {{ $t("add") }} {{ $t("receipts") }} {{ $t("paid") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="part" v-if="hasPermission('client_list') || hasPermission('client_add')">
          <h6>{{ $t("customers") }}</h6>
          <ul>
            <li v-if="hasPermission('client_list')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/allcustomers">
                {{ $t("all") }} {{ $t("customers") }}
              </router-link>
            </li>
            <li v-if="hasPermission('client_add')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/createowner">
                {{ $t("add") }} {{ $t("customer") }} {{ $t("new") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="part" v-if="hasPermission('price_quotation_view') || hasPermission('price_quotation_add')">
          <h6>{{ $t("marketing") }}</h6>
          <ul>
            <li v-if="hasPermission('price_quotation_view')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/allpropertiespriceoffer">
                {{ $t("offer") }} {{ $t("prices") }}
              </router-link>
            </li>
            <li v-if="hasPermission('price_quotation_add')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/createpriceoffer">
                {{ $t("add") }} {{ $t("offer") }} {{ $t("price") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="part">
          <h6>{{ $t("reports") }}</h6>
          <ul>
            <li v-if="hasPermission('owner_account_statement')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/ownerstatement">
                {{ $t("Account Statement") }} {{ $t("owner") }}
              </router-link>
            </li>
            <li>
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/customerstatement">
                {{ $t("Account Statement") }} {{ $t("renter") }}
              </router-link>
            </li>
            <li v-if="hasPermission('rent_due_statement')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/rentalstatement">
                {{ $t("Statement") }} {{ $t("due") }} {{ $t("Rentals") }}
              </router-link>
            </li>
            <li v-if="hasPermission('rent_due_statement')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/RentalsStatementContracts">
                {{ $t("Statement") }} {{ $t("due") }} {{ $t("contracts") }}
              </router-link>
            </li>
            <li v-if="hasPermission('revenue_report')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/RevenuesPropertiesReport">
                {{ $t("report") }} {{ $t("revenues") }}
              </router-link>
            </li>
            <li v-if="hasPermission('client_contracts')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/contractstatment">
                {{ $t("contracts") }} {{ $t("customers") }}
              </router-link>
            </li>
            <li v-if="hasPermission('tax_report_owners')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/TaxReportOwners">
                {{ $t("report") }} {{ $t("tax") }} {{ $t("owners") }}
              </router-link>
            </li>
            <li v-if="hasPermission('expired_contract_report')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/ExpiredContracts">
                {{ $t("report") }} {{ $t("contracts") }} {{ $t("Expired") }}
              </router-link>
            </li>
            <li v-if="hasPermission('receipt_voucher_confirm')">
              <i class="bi bi-three-dots-vertical"></i>
              <router-link to="/property/ArchiveContracts">
                {{ $t("report") }} {{ $t("contracts") }} {{ $t("archive") }}
              </router-link>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["css"],
  data() {
    return {};
  },
  methods: {
    ...mapActions(["redirectTo"]),
    hasPermission(permission) {
      return this.$store?.getters?.hasPermission ? this.$store.getters.hasPermission(permission) : true;
    }
  },
};
</script>

<style lang="scss" scoped>
/* Reset and Container Basics */
.page-container {
  direction: v-bind("css.EN");
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.breadcrumb {
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  
  li a {
    text-decoration: none;
    font-weight: 600;
    font-size: 1.2rem;
    color: #333;
    
    &.active {
      color: v-bind("css.color");
    }
  }
}

/* Main Dashboard Card Wrapper */
.main-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
}

/* Bottom Navigation Grid System */
.body-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px;
}

.part {
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  align-self: start;

  h6 {
    font-size: 16px;
    font-weight: 700;
    color: #1a202c;
    margin-top: 0;
    margin-bottom: 16px;
    border-bottom: 2px solid #edf2f7;
    padding-bottom: 8px;
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .bi-three-dots-vertical {
        color: #a0aec0;
        margin-right: 8px;
        font-size: 14px;
      }

      a {
        color: #4a5568;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: v-bind("css.color");
          font-weight: 500;
        }
      }
    }
  }
}

/* Responsive Breakpoints */
@media screen and (max-width: 992px) {
  .body-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 576px) {
  .page-container {
    padding: 10px;
  }
  
  .main-card {
    padding: 16px;
  }

  .body-grid {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
  
  .part {
    padding: 16px;
    
    h6 {
      font-size: 14px;
      margin-bottom: 12px;
    }
    
    ul li {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}
</style>